const service_names = {
  user: "/user-service",
  school: "/school-service",
  utility: "/utility-service"
};

const service_paths = {
  // users
  staffs: service_names.user + "/staffs",
  students: service_names.user + "/students",
  users: service_names.user + "/users",
  roles: service_names.user + "/roles",
  permissions: service_names.user + "/permissions",
  behavior: service_names.user + "/behavior",
  families: service_names.user + "/families",
  progress: service_names.user + "/progress",

  // utility
  awsS3: service_names.utility + "/s3",
  import: service_names.utility + "/import",
  download: service_names.utility + "/public",
  device_tokens: service_names.utility + "/device-tokens",
  notifications: service_names.utility + "/notifications",
  export: service_names.utility + "/export",
  // school
  dashboard: service_names.school + "/dashboards",
  terms: service_names.school + "/terms",
  classes: service_names.school + "/classes",
  grades: service_names.school + "/grades",
  grade_scales: service_names.school + "/grade-scales",
  graduation_categories: service_names.school + "/graduation-categories",
  programs: service_names.school + "/programs",
  lms: service_names.school + "/lms",
  calendars: service_names.school + "/calendars",
  communication_template: service_names.utility + "/templates",
  communication_notification: service_names.utility + "/notifications",
  subjects: service_names.school + "/subjects",
  subject_rules: service_names.school + "/subject-rules",
  class_activities: service_names.school + "/class-activities",
  class_activity_categories:
    service_names.school + "/class-activity-categories",
  user_academic_plan: service_names.school + "/user-academic-plan",
  reports: service_names.school + "/reports",
  attendances: service_names.school + "/attendances",
  sri_smi: service_names.school + "/sri-smi",
  schools: service_names.school + "/schools",
  ielts: service_names.school + "/ielts",
  toefl: service_names.school + "/toefl",
  student_information: service_names.school + "/student-information",
  survey: service_names.school + "/survey",
  report_surveys: service_names.school + "/report-surveys",
  communication_logs: service_names.school + "/reports/communication-logs",
  communication_log: service_names.school + "/communication-log",
  chat: service_names.user + "/chat"
};

const cms_service_names = {
  program: "/itoprogram",
  courses: "/itolearning",
  classes: "/itocatalog"
};

const cms_service_paths = {
  program_learning: cms_service_names.program +  "/getlearningprograms", //Post
  courses: cms_service_names.program +  "/getgradesubject_update_sis", //Post
  class_add: cms_service_names.classes +  "/class_add",
  class_update: cms_service_names.classes +  "/class_update",
  class_delete: cms_service_names.classes +  "/class_delete",
  assign_students: cms_service_names.classes +  "/student_class_add",
  assign_teachers: cms_service_names.classes +  "/teacher_class_add",
  unassign_students: cms_service_names.classes +  "/unassign_student_classes",
  update_class_status: cms_service_names.classes +  "/update_class_status",
}

export { service_names, service_paths, cms_service_names, cms_service_paths };
